var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmCreate(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4459,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 741 576 h 30 q 4 0 4 4 v 352 q 0 4 -4 4 h -30 q -4 0 -4 -4 v -352 q 0 -4 4 -4 z m -145 161 h 336 q 4 0 4 4 v 30 q 0 4 -4 4 h -352 q -4 0 -4 -4 v -30 q 0 -4 4 -4 z",
    fill: "#E25D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M887.466667 162.133333l-51.2-38.4-76.8 93.866667 46.933333 38.4 81.066667-93.866667zM486.4 21.333333h64v122.88h-64zM273.066667 217.6L200.533333 123.733333l-51.2 38.4L226.133333 256l46.933334-38.4zM512 204.8a332.8 332.8 0 0 0-337.066667 332.8v341.333333H512v-59.733333H422.4V512H362.666667v307.2h-128v-281.6A273.066667 273.066667 0 0 1 512 268.8a285.866667 285.866667 0 0 1 285.866667 247.466667 179.2 179.2 0 0 1 64 17.066666A345.6 345.6 0 0 0 512 204.8zM601.6 942.933333H51.2v59.733334h618.666667a192 192 0 0 1-68.266667-59.733334z ",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmCreate);
export default __webpack_public_path__ + "static/media/alarm-create.b8285e2a7dff8a9968330bd42029abcb.svg";
export { ForwardRef as ReactComponent };